import { isMobile } from './index';
import { EventManager, getStyle, setStyle } from './dom';
export default class DragHandler {
    constructor(source, target, callback = () => { }, transform = true) {
        this.dom = source;
        this.target = target || source;
        this.callback = callback;
        this.transform = transform;
        this.em = new EventManager(source);
        this.emDocument = new EventManager(document);
        this.on();
    }
    on() {
        const element = this.target;
        if (!this.transform) { // offset方式移动需position部位static
            const style = getStyle(element, 'position');
            if (style === 'static') {
                setStyle(element, 'position', 'relative');
            }
        }
        if (isMobile) {
            this.startEvent = this.em.on('touchstart', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const posStart = e.changedTouches[0];
                let moveEvent;
                if (this.transform) { // transform位移
                    const disx = posStart.pageX;
                    const disy = posStart.pageY;
                    moveEvent = this.emDocument.on('touchmove', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const posMove = e.changedTouches[0];
                        element.style.transform = `translate(${posMove.pageX - disx}px,${posMove.pageY - disy}px)`;
                        this.callback(e);
                    });
                }
                else { // offset定位
                    const disx = posStart.pageX - element.offsetLeft;
                    const disy = posStart.pageY - element.offsetTop;
                    moveEvent = this.emDocument.on('touchmove', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const posMove = e.changedTouches[0];
                        element.style.left = `${posMove.pageX - disx}px`;
                        element.style.top = `${posMove.pageY - disy}px`;
                        this.callback(e);
                    });
                }
                const toucheEnd = this.emDocument.on('touchend', () => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.emDocument.off(moveEvent);
                    this.emDocument.off(toucheEnd);
                });
            });
        }
        else {
            this.startEvent = this.em.on('mousedown', (e) => {
                e.preventDefault();
                e.stopPropagation();
                let mousemove;
                if (this.transform) {
                    const disx = e.pageX;
                    const disy = e.pageY;
                    mousemove = this.emDocument.on('mousemove', (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        element.style.transform = `translate(${e.pageX - disx}px,${e.pageY - disy}px)`;
                        this.callback(e);
                    });
                }
                else {
                    const disx = e.pageX - element.offsetLeft;
                    const disy = e.pageY - element.offsetTop;
                    mousemove = this.emDocument.on('mousemove', (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        element.style.left = `${e.pageX - disx}px`;
                        element.style.top = `${e.pageY - disy}px`;
                        this.callback(e);
                    });
                }
                const mouseup = this.emDocument.on('mouseup', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.emDocument.off(mousemove);
                    this.emDocument.off(mouseup);
                    // this.em.off(mouseleave)
                });
                // const mouseleave = this.em.on('mouseleave', (e:MouseEvent) => {
                //   e.preventDefault()
                //   e.stopPropagation()
                //   this.em.off(mousemove)
                //   this.em.off(mouseup)
                //   this.em.off(mouseleave)
                // })
            });
        }
    }
    pause() {
        this.em.off(this.startEvent);
    }
    off() {
        this.em.clear();
    }
}
